import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  page: {
    boxSizing: 'border-box',
    maxWidth: 960,
    padding: theme.spacing(3, 4.5, 6),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3, 2, 6),
    },
  },
  upgradeContent: {
    boxSizing: 'border-box',
    padding: theme.spacing(3, 4.5, 2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3, 2, 2),
    },
  },
  tableShell: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    backgroundColor: theme.palette.common.white,
    overflow: 'auto',
  },
  upgradeTableShell: {
    marginTop: theme.spacing(2),
  },
  card: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  cardTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  summaryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: theme.spacing(3),
  },
  summaryLabel: {
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
  summaryValue: {
    fontSize: '0.9375rem',
    color: theme.palette.text.primary,
  },
  summaryHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  video: {
    width: '100%',
    maxHeight: 480,
    borderRadius: 8,
    backgroundColor: '#172024',
  },
  actionRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },
  contextList: {
    display: 'grid',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  notes: {
    whiteSpace: 'pre-wrap',
    fontSize: '0.9375rem',
    lineHeight: 1.6,
  },
  helper: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    marginBottom: theme.spacing(2),
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
}))

export default useStyles
